<script>
  'use strict'

  import { HorizontalBar, mixins } from 'vue-chartjs'

  const { reactiveProp } = mixins

  export default {
    extends: HorizontalBar,

    mixins: [reactiveProp],

    props: ['chartData', 'options'],

    mounted () {
      this.renderChart(this.chartData, this.options)
    },

    watch: {
      options: {
        handler: function (newVal, oldVal) {
          this.renderChart(this.chartData, this.options)
        },
        deep: true
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/vue-chart/charts/horizontal-bar.vue